import { SearchInput } from '@shared/components'
import { Space } from 'antd'

export const MediaHeader = () => {
  return (
    <Space>
      <SearchInput />
    </Space>
  )
}
